import { Input } from 'antd'
import TextArea from 'antd/lib/input/TextArea'

import { formatNumberWithSpaces, numberWithSpacesIntl } from '@utils/numberWithSpaces'

const OrderTotalsSection = ({
	t,
	handleDateChange,
	docTotal,
	currency,
	totalKvm,
	totalPerimetrToM,
	inputDocTotal,
	handleDocTotalBlur,
	handleDocTotalChange,
	isDiscountBigger,
	sendFile,
	setSendFile,
	setComments,
}) => (
	<div className="flex gap-10 mt-20 drop-shadow-lg bg-white p-5 rounded-lg">
		<div className="w-full flex flex-col  gap-6 ">
			<div className="flex flex-col items-start gap-3 ">
				<p className="font-nunito">{t('deadLine')}</p>
				<Input
					type={'number'}
					onWheel={(e) => e.target.blur()}
					min={0}
					className={'w-full h-10'}
					onChange={handleDateChange}
				/>
			</div>
			<div className="flex   gap-5 items-end">
				<div className="flex flex-col items-start gap-3">
					<p className="font-nunito">{t('minTotal')}</p>
					<Input
						type="text"
						value={`${numberWithSpacesIntl(docTotal || 0)} ${currency}`}
						className="h-10 w-full "
						style={{ color: 'black' }}
						disabled
					/>
				</div>
				<div className="flex flex-col items-start gap-3">
					<p className="font-nunito">{t('totalKvm')}</p>
					<Input
						type="text"
						value={totalKvm}
						className="h-10 w-full "
						style={{ color: 'black' }}
						disabled
					/>
				</div>
				<div className="flex flex-col items-start gap-3">
					<p className="font-nunito">
						{t('totalPerimeter')} ({t('m')})
					</p>
					<Input
						type="text"
						value={formatNumberWithSpaces(
							(totalPerimetrToM.height +
								totalPerimetrToM.width) *
								2 *
								totalPerimetrToM.quantity,
						)}
						className="h-10 w-full "
						style={{ color: 'black' }}
						disabled
					/>
				</div>
			</div>
			{/* <div className="flex   gap-5 items-end">
				<div className="flex flex-col items-start gap-3">
					<p className="font-nunito">
						{t('arendaTotal')}
					</p>
					<Input
						type="text"
						value={formatNumberWithSpaces(
							arendaTotal?.total,
						)}
						className="h-10 w-full "
						style={{ color: 'black' }}
						disabled
					/>
				</div>
				<div className="flex flex-col items-start gap-3">
					<p className="font-nunito">
						{t('ishHaqiTotal')}
					</p>
					<Input
						type="text"
						value={formatNumberWithSpaces(
							ishHaqiTotal?.total,
						)}
						className="h-10 w-full "
						style={{ color: 'black' }}
						disabled
					/>
				</div>
				<div className="flex flex-col items-start gap-3">
					<p className="font-nunito">
						{t('elektrTotal')}
					</p>
					<Input
						type="text"
						value={formatNumberWithSpaces(
							elektrTotal?.total,
						)}
						className="h-10 w-full "
						style={{ color: 'black' }}
						disabled
					/>
				</div>
				<div className="flex flex-col items-start gap-3">
					<p className="font-nunito">
						{t('stanokTotal')}
					</p>
					<Input
						type="text"
						value={formatNumberWithSpaces(
							stanokTotal?.total,
						)}
						className="h-10 w-full "
						style={{ color: 'black' }}
						disabled
					/>
				</div>
			</div> */}
			<div className="flex flex-col items-start gap-3 ">
				<p className="font-nunito">{t('docTotal')}</p>
				<Input
					value={formatNumberWithSpaces(inputDocTotal)}
					className={'w-full h-10'}
					min={docTotal || 0}
					suffix={
						<span className="text-gray-400">UZS</span>
					}
					onBlur={handleDocTotalBlur}
					onChange={handleDocTotalChange}
				/>
				{isDiscountBigger && (
					<p className="text-red-600 font-nunito">
						{t('docTotalBigger')}{' '}
						{numberWithSpacesIntl(docTotal) || 0}
					</p>
				)}
			</div>

			{/* <div className="flex flex-col items-start gap-3 ">
				<p className="font-nunito">{t('Discount')}</p>
				<Input
					// type={'number'}
					controls={false}
					value={
						docTotalWithDiscount,
					}
					className={'w-full'}
					min={0}
					onChange={(e) => {
						const val = e.target.value
						if (
							val <=
							(docTotal / 100) *
								get(getMe, 'u_Discount', 1)
						) {
							setDocTotalWithDiscount(val)
							setIsDiscountBigger(false)
						} else {
							setIsDiscountBigger(true)
						}
					}}
				/>
				{isDiscountBigger && (
					<p className="text-red-600 font-nunito">
						{t('discountBigger')}{' '}
						{(docTotal / 100) *
							get(getMe, 'u_Discount', 1) || 0}
					</p>
				)}
			</div> */}
			<div className="flex flex-col items-start gap-3 w-full">
				<p className="font-nunito">{t('sendFile')}</p>
				<Input
					type="checkbox"
					value={sendFile}
					onChange={(e) => {
						setSendFile(e.target.checked)
					}}
					className="w-fit"
				/>
			</div>
		</div>

		<div className="w-full flex  h-full">
			<div className="flex flex-col items-start gap-3 w-full">
				<p className="font-nunito">{t('comments')} </p>
				<TextArea
					className={'w-full'}
					rows={11}
					onChange={(e) => {
						setComments(e.target.value)
					}}
				/>
			</div>
		</div>
	</div>
)

export default OrderTotalsSection
